/** Single source of truth for site navigation destinations */
export const SITE_LINKS = {
  home: '/',
  shop: '/shop',
  collections: '/collections',
  about: '/about',
  contact: '/#contact',
  cart: '/cart',
  wishlist: '/wishlist',
  orders: '/orders',
  login: '/login',
  signup: '/signup',
  serviceNetwork: '/services/network-infrastructure',
  serviceSecurity: '/services/digital-security',
}

export const MAIN_NAV = [
  { label: 'Home', href: SITE_LINKS.home },
  { label: 'Shop', href: SITE_LINKS.shop },
  { label: 'Contact', href: SITE_LINKS.contact },
]

export const FOOTER_EXPLORE = [
  { label: 'Home', href: SITE_LINKS.home },
  { label: 'Shop', href: SITE_LINKS.shop },
  { label: 'Contact Us', href: SITE_LINKS.contact },
]

export const CONTACT_INFO = {
  email: 'info@fabritech.rw',
  phone: '+250 788 601 280',
  phoneHref: 'tel:+250788601280',
  emailHref: 'mailto:info@fabritech.rw',
  address: 'YYUSSA Plaza, Kisimenti, Remera',
  mapsHref: 'https://maps.google.com/?q=YYUSSA+Plaza+Kisimenti+Remera+Kigali',
}

// Company social accounts, shown in the header top bar and the footer.
export const SOCIAL_LINKS = [
  { label: 'Instagram', icon: 'fa-instagram', href: 'https://www.instagram.com/fabritech_ltd/' },
  { label: 'LinkedIn', icon: 'fa-linkedin-in', href: 'https://www.linkedin.com/company/145362416/' },
  { label: 'X', icon: 'fa-x-twitter', href: 'https://x.com/Fabritech_ltd' },
]
